import {
  MDBBtn,
  MDBCheckbox,
  MDBModalFooter,
  MDBSelect,
  MDBTimepicker
} from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useFieldArray, useForm } from "react-hook-form";
import remove from "../../../components/images/remove.svg";
import { formattedNumber, validatePhoneNumber } from "../phonenumbers/AddRemoveNumbers";

const AddCRDevice = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [ditem, setDitem] = useState({});
  // const [is24Enabled, setIs24Enabled] = useState(false);
  // const enable24Hrs = () => setIs24Enabled(!is24Enabled);
  const [issystemroute, setIssystemroute] = useState(false);
  // const [routingPlans, setRoutingPlans] = useState([]);
  const [name, setName] = useState("Streams IP Phone 1")
  const [fromtime, setFromtime] = useState("10:00 am");
  const [totime, settoTime] = useState("07:00 pm");
  const [enableCallerId, setEnableCallerId] = useState(true);
  const [displayExternal, setdisplayExternal] = useState(false);
  const [defaultDeviceList, setDefaultDeviceList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [selectedOptions, setselectedOptions] = useState([])
  const [calleridList, setcalleridList] = useState([]);
  const { register, formState, handleSubmit, setValue, getValues, setError, clearErrors, watch, control } = useForm({
    defaultValues: {

      device_type: [1],
      device_type_external: 0,
      ftime: "12:00 AM",
      ttime: "11:59 PM",
      // is24Enabled: false,
      new_external_num: "",
      callerid_pass_flag: true,
      callerid_pass: "0",
      external_num_title: "",
      external_num: "",
      external_num_save: false,
      device_name: "IP Phone1",
      displayCallerId: false,
      is24: true,

    }
  });

  const { fields } = useFieldArray({
    control,
    name: "devices",
  })

  useEffect(() => {
    if (props.callerids?.length > 0) {
      setcalleridList(props.callerids.map((item) => ({ text: item.addl_info, value: item.phnum })));

    }

  }, [props.callerids])

  useEffect(() => {
    if (props.deviceExternalNum && props.deviceExternalNum.length > 0) {
      // setDeviceList(props.deviceExternalNum);
      const transformData = props.deviceExternalNum.map(entry => ({ text: entry.type && entry.type.indexOf(":") !== -1 ? entry.type.split(":")[0] +": "+ formattedNumber(entry.type.split(":")[1]) : entry.type, value: entry.id }));
      let filterData = transformData;
      console.log("data after set  ::::::::::: " + JSON.stringify(transformData));
      console.log("datatatatatatat ::::::::::: " + JSON.stringify(props.deviceFields));
      if (props.deviceFields && props.deviceFields.length > 0) {
        const devType = props.deviceFields.map(device => parseInt(device.device_type));
        const devTypeExt = props.deviceFields.filter(device => device.external_num).map(device => device.external_num + "");
        filterData = transformData.filter(device => !devType.includes(device.value));
        console.log("lllllllllllll ::::::::::: " + JSON.stringify(devTypeExt));
        filterData = filterData.filter(device => !devTypeExt.includes(device.value));
        console.log("filter data :::::: " + JSON.stringify(filterData));
      }
      const devids = filterData.map(element => element.value);
      setValue("device_type", devids, { shouldDirty: true });



      setDeviceList(filterData);

    }
  }, [props.deviceExternalNum]);

  const { isDirty, errors } = formState;

  // useEffect(() => {
  //   console.log(props.ditem)
  //   if (props.ditem) {
  //     setDitem(props.ditem);
  //     setIs24Enabled(props.ditem.is24);
  //   }
  // }, [props.ditem]);

  // const randomNumericId = () => Math.floor(Math.random() * 1000000);
  // const id = randomNumericId();

  const onsubmit = (data) => {
    // if (!validateDeviceType(deviceName, data.device_type)) {
    let devices = [];

    console.log("selectedOptions :::::::::: " + JSON.stringify(selectedOptions));

    selectedOptions.map((device, index) => {

      devices.push({
        deviceid: "",
        device_type: device.value.length > 1 ? 5 : parseInt(device.value),
        ftime: data.ftime,
        ttime: data.ttime,
        new_external_num: "",
        displayCallerId: device.value.length > 1 ? true : false,
        callerid_pass_flag: true,
        callerid_pass: "0",
        is24: data.is24,
        newDevice: true,
        external_num_title: device.value.length > 1 ? device.text.split(":")[0] : "",
        external_num: device.value.length > 1 && device.value !== "" ? parseInt(device.value) : "",
        external_num_save: false,
        name: device.text,
      })
    });


    if (data.device_type_external && data.device_type_external === 5) {
      if (data.callerid_pass_flag !== undefined && !data.callerid_pass_flag && data.callerid_pass === "0") {
        setError("callerid_pass", { message: "Caller ID is required." });
        return;
      }
      if (data.external_num_title !== "" && data.new_external_num !== "") {
        devices.push({
          deviceid: "",
          device_type: 5,
          ftime: data.ftime,
          ttime: data.ttime,
          new_external_num: data.new_external_num,
          displayCallerId: true,
          callerid_pass_flag: data.callerid_pass_flag,
          callerid_pass: data.callerid_pass,
          is24: data.is24,
          newDevice: true,
          external_num_title: data.external_num_title,
          external_num: "",
          external_num_save: data.external_num_save,
          name: `${data.external_num_title}:${data.new_external_num}`,
        });
      }

    }
    props.addDevice(devices);
  }
  const mustChooseCallerId = (val) => {
    const flag = getValues("callerid_pass_flag");
    const deviceType = getValues("device_type_external");
    const empty = (deviceType === 5 && (val == null || val === "" || val === "0"));
    return flag || !empty
      ? true
      : "Caller ID is required.";
  };

  const [isOpen, setIsOpen] = useState(false);
  const displayExternalNumber = () => {
    // debugger;
    clearErrors("device_type");

    setdisplayExternal(true);
    setIsOpen(false);
    setValue("displayCallerId", true, { shouldDirty: true });
    setValue("device_type_external", 5, { shouldDirty: true });

    // alert(obj.id)


  }

  // const validateDeviceType = (deviceName, type) => {
  //   const matchIndex = props.deviceFields.findIndex((item) => item.name.toString().trim() === deviceName.toString().trim());
  //   if (matchIndex !== -1) {
  //     setError("device_type", {
  //       message: "Device Name should not be duplicate."
  //     });
  //     return true;
  //   }
  //   return false;



  // }

  const handleDeviceTypeChange = (values) => {

    setselectedOptions(values);
    setdisplayExternal(false);
    const deviceTypes = values.map(device => device.value);
    setValue("device_type", deviceTypes, { shouldDirty: true });

  }
  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    if (Array.isArray(deviceList) && deviceList.length === 0) {
      // Execute your code here
      displayExternalNumber();
    }
  }, [deviceList]);

  const handleDuplicateNumber = (value) => {
    if (value && value !== "") {
      const isDuplicate = props.deviceFields.some((item) => {
        return (item.external_num && item.external_num !== "" && formattedNumber(item.external_num.toString()) === formattedNumber(value.toString()) || item.new_external_num && item.new_external_num !== "" && formattedNumber(item.new_external_num.toString()) === formattedNumber(value.toString()));
      });
      if (isDuplicate) {
        return "Number already exists.";
      }
    }
    return true;
  }
  const handleDuplicateName = (value) => {
    if (value && value !== "") {
      const isDuplicate = props.deviceFields.some((item) => {
        return (item.name && (item.name.indexOf(":") !== -1) && item.name.split(":")[0]?.trim()  === value.trim());
      });
      if (isDuplicate) {
        return "Name already exists.";
      }
    }
    return true;
  }

  const handleCapitalizedChange = (e) => {
  const originalValue = e.target.value;

  const capitalized =
    originalValue.length > 0
      ? originalValue.charAt(0).toUpperCase() + originalValue.slice(1)
      : "";

  setValue("external_num_title", capitalized, {
    shouldValidate: true,
    shouldDirty: true,
  });
};


  return (
    <>
      <form>
        <div className=" mb-2">
          <div className="sequenceheader">
            <label className="fw-bold">{ditem.name}</label>
            {props.mode && props.mode == "1" && (
              <img src={remove} className="close-icon" onClick={(e) => props.onClose(e)} />
            )}
          </div>
          <div >
            {deviceList && deviceList.length > 0 ? (
              <div className="phoneselect w-50 mb-3">
                <MDBSelect
                  dismiss
                  onOpen={() => setIsOpen(!isOpen)}
                  onClose={() => setIsOpen(!isOpen)}
                  // onClose={() => setIsOpen(false)}
                  open={isOpen}
                  className="w-100 m-0"
                  data={deviceList}
                  selectAll={true}
                  value={watch("device_type")}
                  multiple
                  search
                  onChange={handleDeviceTypeChange}
                  placeholder={displayExternal ? 'Add New External Number' : 'Select Device'}
                >
                  <p className="cursor-pointer" onClick={(e) => {
                    e.preventDefault();
                    displayExternalNumber();
                  }}>Add New External Number</p>
                </MDBSelect>
              </div>
            ) : (
              <p className=""
              // onClick={(e) => {
              //   e.preventDefault();
              //   displayExternalNumber()
              // }}
              >Add New External Number</p>)}
            {errors.device_type && (

              <p className="text-danger">{errors.device_type.message}</p>
            )}
            {displayExternal &&
              <div>
                <div>

                  <div className='mt-2 d-flex align-itemd-center justify-content-between w-80'>
                    <div className="tel-numbers fw-bold">{t("name")}</div>
                    <MDBCheckbox name='checkNoLabel' id='checkboxNoLabel'
                      defaultValue={watch("external_num_save")}
                      onChange={(e) => {
                        setValue("external_num_save", e.target.checked, { shouldDirty: true });

                      }}
                      label="Save" />
                  </div>
                  <div className="phoneselect mt-1 w-80">
                    <input
                      type="text"
                      maxLength={25}
                      {...register("external_num_title", {
                        required: "Name should not be empty",
                        validate: handleDuplicateName,
                        maxLength: {
                          value: 25,
                          message: "Name should not be longer than 25 characters"
                        },
                        onChange: handleCapitalizedChange
                      })}
                      className="form-control"
                    />
                     <p className="mb-0 text-muted text-start w-100" style={{fontSize:'11px'}}>Maximum 25 characters allowed.</p>
                    {errors.external_num_title && (
                      <p className="text-danger">{errors.external_num_title.message}</p>
                    )}
                  </div>

                  <div className="mt-2 d-flex align-items-center justify-content-between w-80">
                    <div className="tel-numbers fw-bold">{t("Number")}</div>
                  </div>

                  <div className="phoneselect mt-1 w-80">
                    <input
                      type="text"
                      maxLength={17}
                      {...register("new_external_num", {
                        required: "Number should not be empty",
                        validate: {
                          isValidPhone: validatePhoneNumber,
                          isduplicate: handleDuplicateNumber,
                        },
                        maxLength: {
                          value: 17,
                          message: "Number should not be longer than 17 characters"
                        }
                      })}
                      // onKeyPress={(event) => {
                      //   if (!/[0-9]/.test(event.key)) {
                      //     event.preventDefault();
                      //   }
                      // }}
                      className="form-control"
                    />
                   
                    {errors.new_external_num && (
                      <p className="text-danger">{errors.new_external_num.message}</p>
                    )}
                  </div>

                  <div className='mt-2 d-flex align-itemd-center justify-content-between w-80'>
                    <div className="tel-numbers fw-bold">{t("CallerIDpasstrough")}</div>
                    <MDBCheckbox name='checkNoLabel' id='checkboxNoLabel'
                      defaultChecked={getValues("callerid_pass_flag")}
                      onClick={(e) => {
                        clearErrors("callerid_pass");
                        setEnableCallerId((obj) => !obj);
                        setValue("callerid_pass_flag", e.target.checked, { shouldDirty: true });
                      }}
                    />
                  </div>
                  <div>
                    <MDBSelect search className="phoneselect mt-1 w-80"  data={[{ text: "Choose CallerID", value: "0" }, ...calleridList]}
                      disabled={enableCallerId} name="Default"
                      {...register("callerid_pass", { validate: mustChooseCallerId })}
                      onChange={(e) => {
                        clearErrors("callerid_pass");
                        setValue("callerid_pass", e.value, { shouldDirty: true })
                      }}
                    />
                    {/* <option value="0">Choose CallerID</option>
                      {props.callerids && props.callerids.length > 0 && props.callerids.map((item) => (
                        <option key={item.phnum} value={item.phnum}>
                          {item.addl_info}
                        </option>
                      ))} */}
                    {/* </MDBSelect> */}
                    {errors.callerid_pass && (
                      <p className="text-danger">{errors.callerid_pass.message}</p>
                    )}
                  </div>
                </div>
              </div>
            }
            <div className=" d-flex justify-content-between align-items-center py-3  mb-4">
              <label className="px-0 pe-2">{t("from")}</label>
              <MDBTimepicker inline
                // style={{ width: "140px" }}
                cancelLabel="true"
                inputLabel="Time"
                defaultValue={getValues("ftime")}
                className="w-30"
                disabled={watch("is24")}

                // disabled={is24Enabled || props.issystemroute ? true : false}
                onChange={(value) => {
                  setValue("ftime", value, { shouldDirty: true });
                }}
              />
              <label className="px-2">{t("to")}</label>
              <MDBTimepicker inline
                // style={{ width: "140px" }}
                cancelLabel="true"
                inputLabel="Time"
                defaultValue={getValues("ttime")}
                className="w-30"
                disabled={watch("is24")}
                // disabled={is24Enabled || props.issystemroute ? true : false}
                onChange={(value) => {
                  setValue("ttime", value, { shouldDirty: true });
                }}
              />
              &nbsp;
              <span className="ml-1">
                <MDBCheckbox
                  className="me-0"
                  defaultChecked={getValues("is24")}
                  onChange={(e) => setValue("is24", e.target.checked, { shouldDirty: true })}
                  name="flexCheck"
                  value=""
                  // disabled={is24Enabled}
                  id="flexCheckDefault"
                  label="All Day"
                />
              </span>
            </div>
          </div>
        </div>
        {/* <MDBModalFooter>
          <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
            {t("close")}
          </MDBBtn>
          <MDBBtn onClick={handleSubmit(onsubmit)}>{t("add")}</MDBBtn>
        </MDBModalFooter> */}
        <div style={{ display: "none" }}>
          <button ref={ref} onClick={handleSubmit(onsubmit)}>
            {t("add")}</button>
        </div>
      </form>
    </>
  );
});
export default AddCRDevice;
